import React, { Component } from "react";
import ReportHeader from "../Reports/Common/ReportHeader";
import ReportBody from "../Reports/Common/ReportBody";
import Input from "../2/Controls/Input";
import ReportButton from "../Reports/Common/ReportButton";
import Spinner from "../Common/Spinner";
import Pagination from "react-js-pagination";
import axios from "axios";
import * as constatnts from "../../Constatnts";

class WHInboundVerificationView extends Component {
  constructor() {
    super();
    this.state = {
      fromDate: null,
      toDate: null,
      verificationStatus: "pending",
      store: "",
      smartStoreList: [],
      approvalStatus: "Pending",
      selectedStoreID: "",
      records: [],
      showViewDetails: true,
      selectedRecord: null,
      from: 0,
      size: 50,
      loading: false,
      activePage: 1,
      paginationStatus: "No records to display",
      buttons: [],
      approvedAmountError: "",
      SONo: "",
      SINo: "",
      verificationStatus: "",
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.showPaginationStatus = this.showPaginationStatus.bind(this);
    this.save = this.save.bind(this);
  }

  async componentDidMount() {
    await this.populateSmartStores();
    this.loadData(
      this.state.activePage,
      this.state.size,
      this.state.selectedStoreID,
      this.state.fromDate,
      this.state.toDate,
      this.state.approvalStatus,
      this.state.SONo,
      this.state.SINo,
      this.state.verificationStatus,
      false
    );
  }

  async loadData(
    page,
    size,
    storeID,
    fromDate,
    toDate,
    status,
    SONo = "",
    SINo = "",
    verificationStatus = "",
    exportData = false
  ) {
    this.setState({ loading: true });
    var headers = {};
    var params = {
      page: page,
      limit: size,
      filters: {},
    };

    if (storeID) params.storeID = storeID;
    if (status) {
      params.filters.status = status;
      if (status === "Completed") params.sort = "desc";
    }
    if (fromDate && toDate) {
      params.filters.fromDate = fromDate;
      params.filters.toDate = toDate;
    }
    if (SINo && SINo.trim() !== "") params.filters.SINo = SINo.trim();
    if (SONo && SONo.trim() !== "") params.filters.SONo = SONo.trim();
    if (verificationStatus && verificationStatus.trim() !== "")
      params.filters.verificationstatus = verificationStatus.trim();

    var BaseURL = "https://backend-197598313260.asia-south1.run.app";
    var stores = this.state.smartStoreList || [];
    var allRecords = [];
    var totalItemsCount = 0;

    async function fetchPageData(pageNum) {
      const response = await axios.get(BaseURL + "/v1/whinbound", {
        params: Object.assign({}, params, { page: pageNum }),
        headers: Object.assign({ "Content-Type": "application/json" }, headers),
      });

      if (
        response &&
        response.data &&
        response.data.data &&
        Array.isArray(response.data.data) &&
        response.data.data.length > 0
      ) {
        if (
          !totalItemsCount &&
          response.data.pagination &&
          response.data.pagination.total
        ) {
          totalItemsCount = response.data.pagination.total;
        }

        var records = response.data.data.map(function(data) {
          var storeName = "";
          var matched = stores.find(function(f) {
            return f.key === data.StoreID;
          });
          if (matched) storeName = matched.StoreName;

          return {
            key: data._id,
            RegistrationID: data.RegistrationID,
            StoreID: data.StoreID,
            StoreName: storeName,
            SONo: data.SONo,
            InvoiceNo: data.SINo,
            InvoiceDate: data.CreatedDate
              ? new Date(data.CreatedDate).toLocaleDateString()
              : "",
            InvoiceQty: data.SIQty,
            InvoiceAmount: data.SIAmount,
            TotalInwardQty: data.TotalInwardQty,
            TotalDamageQty: data.TotalDamageQty,
            TotalShortQty: data.TotalShortQty,
            Status: data.Status,
            ReceivingTime: data.ReceivingTime
              ? new Date(data.ReceivingTime).toLocaleString()
              : "",
            CompletionTime: data.CompletedTime
              ? new Date(data.CompletedTime).toLocaleString()
              : "",
            ApprovalStatus: data.ApprovalStatus ? data.ApprovalStatus : "",
          };
        });
        return records;
      }
      return [];
    }

    if (exportData) {
      // First call to get pagination info
      const firstResponse = await axios.get(BaseURL + "/v1/whinbound", {
        params: params,
        headers: Object.assign({ "Content-Type": "application/json" }, headers),
      });

      if (
        firstResponse &&
        firstResponse.data &&
        firstResponse.data.pagination &&
        firstResponse.data.pagination.total
      ) {
        totalItemsCount = firstResponse.data.pagination.total;
      }

      var totalPages = Math.ceil(totalItemsCount / size);
      var firstPageRecords = [];

      if (
        firstResponse &&
        firstResponse.data &&
        firstResponse.data.data &&
        Array.isArray(firstResponse.data.data)
      ) {
        firstPageRecords = firstResponse.data.data.map(function(data) {
          var storeName = "";
          var matched = stores.find(function(f) {
            return f.key === data.StoreID;
          });
          if (matched) storeName = matched.StoreName;

          return {
            key: data._id,
            RegistrationID: data.RegistrationID,
            StoreID: data.StoreID,
            StoreName: storeName,
            SONo: data.SONo,
            InvoiceNo: data.SINo,
            InvoiceDate: data.CreatedDate
              ? new Date(data.CreatedDate).toLocaleDateString()
              : "",
            InvoiceQty: data.SIQty,
            InvoiceAmount: data.SIAmount,
            TotalInwardQty: data.TotalInwardQty,
            TotalDamageQty: data.TotalDamageQty,
            TotalShortQty: data.TotalShortQty,
            Status: data.Status,
            ReceivingTime: data.ReceivingTime
              ? new Date(data.ReceivingTime).toLocaleString()
              : "",
            CompletionTime: data.CompletedTime
              ? new Date(data.CompletedTime).toLocaleString()
              : "",
            ApprovalStatus: data.ApprovalStatus ? data.ApprovalStatus : "",
          };
        });
      }

      allRecords = allRecords.concat(firstPageRecords);

      // Fetch remaining pages sequentially
      for (var i = 2; i <= totalPages; i++) {
        var pageRecords = await fetchPageData(i);
        allRecords = allRecords.concat(pageRecords);
      }

      // Generate CSV
      var csvData = constatnts.objToCSV(allRecords);
      this.setState({ loading: false });
      var csvBlob = new Blob([csvData], { type: "text/csv" });
      var url = window.URL.createObjectURL(csvBlob);
      var a = document.createElement("a");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", "whinbound_report.csv");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      return;
    }

    // Normal paginated view
    var pageRecords = await fetchPageData(page);
    this.setState({
      records: pageRecords,
      totalItemsCount: totalItemsCount,
      loading: false,
    });
    this.showPaginationStatus(totalItemsCount, (page - 1) * size);
  }

  async populateSmartStores() {
    let smartStores = this.props.config.SmartStores;
    console.log("smartStores", smartStores);
    if (smartStores.length === 0) {
      let registrations = await this.props.getPincodeSmartRegistrations();
      let tmp = await this.props.getPincodeStores(registrations);
      // let smartStores = [];
      if (tmp && tmp.searchResult && tmp.searchResult.length > 0) {
        tmp.searchResult.map((s) => {
          if (
            s.PincodeServiceProviderID &&
            s.PincodeServiceProviderID.trim() !== ""
          ) {
            smartStores.push(s);
          }
        });
      }
      this.props.setSmartStores(smartStores);
      // console.log("tmp", tmp);
    }

    this.setState({ smartStoreList: smartStores });
  }

  async save(record) {
    this.setState({ saving: true });
    console.log("record", record);
    const response = await axios.put(
      "https://pincodebackgroundprocess-706168875042.asia-south1.run.app/update/expiry/products/" +
        record.id,
      {
        ...record,
      }
    );

    setTimeout(
      function() {
        //Start the timer
        this.loadData(
          this.state.pageNumber,
          this.state.size,
          this.state.selectedStoreID,
          this.state.fromDate,
          this.state.toDate,
          this.state.approvalStatus,
          this.state.SONo,
          this.state.SINo,
          this.state.verificationStatus,
          false
        );
        this.setState({
          showViewDetails: false,
          approvedAmountError: "",
          saving: false,
        });
      }.bind(this),
      3000
    );
  }

  showPaginationStatus(totalItemsCount, recordFrom) {
    let paginationStatus;
    if (totalItemsCount === 0) {
      paginationStatus = "No records to display";
    } else if (recordFrom + 1 === totalItemsCount) {
      paginationStatus =
        "Showing " + totalItemsCount + " of " + totalItemsCount;
    } else if (recordFrom + this.state.size + 1 > totalItemsCount) {
      paginationStatus =
        "Showing " +
        (recordFrom + 1) +
        " to  " +
        totalItemsCount +
        " of " +
        totalItemsCount;
    } else {
      paginationStatus =
        "Showing " +
        (recordFrom + 1) +
        " to  " +
        (recordFrom + this.state.size) +
        " of " +
        totalItemsCount;
    }
    this.setState({ paginationStatus: paginationStatus });
  }

  removeTimeFromISO(dateStr) {
    if (!dateStr) return dateStr;

    // Convert to string safely
    const str = String(dateStr);

    // Check if it’s an ISO format with time
    if (str.includes("T")) {
      return str.split("T")[0]; // Keep only YYYY-MM-DD
    }

    return str; // already clean
  }

  handlePageChange(pageNumber) {
    this.setState({ activePage: pageNumber });
    this.loadData(
      pageNumber,
      this.state.size,
      this.state.selectedStoreID,
      this.state.fromDate,
      this.state.toDate,
      this.state.approvalStatus,
      this.state.SONo,
      this.state.SINo,
      this.state.verificationStatus,
      false
    );
  }

  render() {
    return (
      <div className="content-wrapper">
        <section className="content">
          <ReportHeader
            title={"WH Inbound"}
            showBack={true}
            onBack={() => {
              //   console.log("back clicked");
              this.props.history.push({ pathname: "/home/" });
            }}
          ></ReportHeader>
          <ReportBody>
            <div className="row">
              <div className="col-md-2">
                <Input
                  type="date"
                  label="From Date"
                  value={this.state.fromDate}
                  onChange={(value) => this.setState({ fromDate: value })}
                />
              </div>
              <div className="col-md-2">
                <Input
                  type="date"
                  label="To Date"
                  value={this.state.toDate}
                  onChange={(value) => this.setState({ toDate: value })}
                />
              </div>
              <div className="col-md-2">
                <Input
                  type="select"
                  label="Store"
                  value={this.state.selectedStoreID}
                  onChange={(value) =>
                    this.setState({ selectedStoreID: value })
                  }
                >
                  <option value="">All</option>
                  {this.state.smartStoreList.map((s) => (
                    <option value={s.key}>{s.StoreName}</option>
                  ))}
                </Input>
              </div>
              <div className="col-md-2">
                <Input
                  type="select"
                  label="Status"
                  value={this.state.approvalStatus}
                  onChange={(value) => this.setState({ approvalStatus: value })}
                >
                  {/* <option value="">All</option> */}
                  <option value="Pending">Pending</option>
                  <option value="Put away - Pending">Put away - Pending</option>
                  <option value="Completed">Completed</option>
                  {/* <option value="Rejected">Rejected</option> */}
                </Input>
              </div>
              <div className="col-md-2">
                <Input
                  type="select"
                  label="Verification Status"
                  value={this.state.verificationStatus}
                  onChange={(value) =>
                    this.setState({ verificationStatus: value })
                  }
                >
                  <option value="Pending">Pending</option>
                  <option value="Put away - Pending">Completed</option>
                </Input>
              </div>
              <div className="col-md-2">
                <Input
                  type="text"
                  label="SO No"
                  value={this.state.SONo}
                  onChange={(value) => this.setState({ SONo: value })}
                />
              </div>
              <div className="col-md-2">
                <Input
                  type="text"
                  label="SI No"
                  value={this.state.SINo}
                  onChange={(value) => this.setState({ SINo: value })}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8"></div>
              <div className="col-md-4">
                <ReportButton
                  type="search"
                  onClick={() => {
                    this.loadData(
                      1,
                      this.state.size,
                      this.state.selectedStoreID,
                      this.state.fromDate,
                      this.state.toDate,
                      this.state.approvalStatus,
                      this.state.SONo,
                      this.state.SINo,
                      this.state.verificationStatus,
                      false
                    );
                  }}
                />
                <ReportButton
                  type="clear"
                  onClick={() => {
                    this.setState({
                      page: 1,
                      size: this.state.size,
                      selectedStoreID: "",
                      fromDate: "",
                      toDate: "",
                      approvalStatus: "Pending",
                      SONo: "",
                      SINo: "",
                      verificationStatus: "",
                    });
                    this.loadData(
                      1,
                      50,
                      "",
                      null,
                      null,
                      "Pending",
                      "",
                      "",
                      "",
                      false
                    );
                  }}
                />
                <ReportButton
                  type="export"
                  onClick={() =>
                    this.loadData(
                      this.state.activePagefrecordFrom,
                      this.state.size,
                      this.state.selectedStoreID,
                      this.state.fromDate,
                      this.state.toDate,
                      this.state.approvalStatus,
                      this.state.SONo,
                      this.state.SINo,
                      this.state.verificationStatus,
                      true
                    )
                  }
                />
              </div>
            </div>
            <br />
            {/* <br /> */}

            <div className="row">
              <div className="col-md-12">
                {this.state.loading && <Spinner />}
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Store Name</th>
                      <th>SO No</th>
                      <th>SI No</th>
                      <th>Invoice Date</th>
                      <th>Invoice Qty</th>
                      <th>Invoice Amount</th>
                      <th>Inward Qty</th>
                      <th>Damage Qty</th>
                      <th>Short Qty</th>
                      <th>Receiving Time</th>
                      <th>Completion Time</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.records.map((record) => (
                      <tr>
                        <td>{record.StoreName}</td>
                        <td>{record.SONo}</td>
                        <td>{record.InvoiceNo}</td>
                        <td>{record.InvoiceDate}</td>
                        <td style={{ textAlign: "right" }}>
                          {record.InvoiceQty}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {record.InvoiceAmount}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {record.TotalInwardQty}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {record.TotalDamageQty}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {record.TotalShortQty}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {record.ReceivingTime}
                        </td>
                        <td>{record.CompletionTime}</td>
                        <td>{record.Status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {this.state.totalItemsCount > 0 && (
              <div className="row">
                <div className="col-md-12">
                  <div className="pull-left" style={{ marginTop: "25px" }}>
                    {this.state.paginationStatus}
                  </div>
                  <div className="pull-right">
                    <Pagination
                      activePage={this.state.activePage} //this.state.activePage
                      itemsCountPerPage={this.state.size}
                      totalItemsCount={this.state.totalItemsCount}
                      pageRangeDisplayed={2}
                      onChange={this.handlePageChange}
                    />
                  </div>
                </div>
              </div>
            )}
          </ReportBody>
        </section>
      </div>
    );
  }
}

export default WHInboundVerificationView;
